import { useQuoteContext } from "@/contexts/quote-context";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const UTM_STORAGE_KEY = "nacional-utm-params";
const UTM_PROCESSED_KEY = "nacional-utm-processed";

export const useUtmParameters = () => {
  const location = useLocation();
  const { updateUtmParameters, utmParameters } = useQuoteContext();
  const hasProcessedRef = useRef(false);
  const lastSearchRef = useRef<string>("");

  useEffect(() => {
    const wasProcessed = sessionStorage.getItem(UTM_PROCESSED_KEY) === "true";

    if (wasProcessed && !location.search) {
      if (Object.keys(utmParameters).length === 0) {
        const storedUtm = sessionStorage.getItem(UTM_STORAGE_KEY);
        if (storedUtm) {
          try {
            const parsedUtm = JSON.parse(storedUtm);
            updateUtmParameters(parsedUtm);
          } catch (error) {
            console.warn(
              "Erro ao fazer parse dos UTM parameters do storage:",
              error
            );
          }
        }
      }
      return;
    }

    if (lastSearchRef.current === location.search) {
      return;
    }

    if (Object.keys(utmParameters).length > 0 && !location.search) {
      return;
    }

    lastSearchRef.current = location.search;

    const searchParams = new URLSearchParams(location.search);

    const utmParams = {
      utm_source: searchParams.get("utm_source") || undefined,
      utm_medium: searchParams.get("utm_medium") || undefined,
      utm_campaign: searchParams.get("utm_campaign") || undefined,
      utm_term: searchParams.get("utm_term") || undefined,
      utm_content: searchParams.get("utm_content") || undefined,
    };

    const hasUtmParams = Object.values(utmParams).some(
      (value) => value !== undefined
    );

    if (hasUtmParams) {
      // console.log("🎯 Novos UTM Parameters detectados:", utmParams);

      const cleanUtmParams = Object.fromEntries(
        Object.entries(utmParams).filter(([, value]) => value !== undefined)
      );

      sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(cleanUtmParams));
      sessionStorage.setItem(UTM_PROCESSED_KEY, "true");

      updateUtmParameters(cleanUtmParams);
      hasProcessedRef.current = true;
    }
  }, [location.search, updateUtmParameters, utmParameters]);

  useEffect(() => {
    if (Object.keys(utmParameters).length === 0) {
      sessionStorage.removeItem(UTM_STORAGE_KEY);
      sessionStorage.removeItem(UTM_PROCESSED_KEY);
    }
  }, [utmParameters]);
};
